<template lang="pug">
.container-restricao.row
    .col-8
        small Foram detectadas sobreposições com as seguintes áreas embargadas pelo IBAMA:

        .list-group
            a.list-group-item.list-group-item-action
                .row
                    label.col-3 TAD
                    label.col-3 Área (ha)
                    label.col-5 Nº da infração

            a.list-group-item.list-group-item-action(
                v-for='(restricao, index) in areaEmbargada.restricoes'
            )
                .row
                    .col-3
                        span(
                            data-toggle='tooltip',
                            data-placement='bottom',
                            data-boundary='body',
                            :title='getDescricaoTad(restricao)'
                        ) {{ getNumeroTad(restricao) }}

                    .col-3
                        span {{ getArea(restricao) }}

                    .col-5
                        span(
                            data-toggle='tooltip',
                            data-placement='bottom',
                            data-boundary='body',
                            :title='getDescricaoAutoInfracao(restricao)'
                        ) {{ getNumeroAutoInfracao(restricao) }}

    .col-4
        mapa(
            v-if='layersMaps',
            :mapLayersConfigs='layersMaps',
            :mapConfig='mapConfig',
            :locked='true',
            :height='"180px"',
            :idMapa='"mapaRestricaoAreaEmbargada"'
        )
</template>

<script>
import Mapa from '@/components/MapaLeaflet';

import LayerStyle from '@/utils/layerStyles';
import formatters from '@/utils/formatters';

export default {
    name: 'AreaEmbargadaIbama',

    components: {
        Mapa
    },

    data() {
        return {
            layersMaps: null,
            mapConfig: {
                controls: {
                    fullscreen: true
                }
            }
        };
    },
    props: {
        areaEmbargada: {
            type: Object,
            required: true
        },

        geometriaAreaMonitorada: {
            type: Object,
            required: true
        }
    },
    methods: {
        configureLayersMapa() {
            this.layersMaps = [];

            let layerAreaMonitorada = {
                style: LayerStyle.AREA_MONITORADA(),
                name: 'Área Monitorada',
                geoJson: this.geometriaAreaMonitorada
            };

            this.layersMaps.push(layerAreaMonitorada);

            this.areaEmbargada.restricoes.forEach(feature => {
                let layerRestricao = {
                    style: LayerStyle.RESTRICAO(),
                    geoJson: feature.geometry,
                    name: 'Áreas embargadas - IBAMA',
                    tooltip: `TAD: ${feature.properties.numero_tad}`
                };

                this.layersMaps.push(layerRestricao);
            });
        },

        getNumeroTad(restricao) {
            return restricao.properties.numero_tad || ' - ';
        },

        getNumeroAutoInfracao(restricao) {
            return restricao.properties.num_auto_infracao || '';
        },

        getDescricaoTad(restricao) {
            return restricao.properties.descricao_tad || '';
        },

        getDescricaoAutoInfracao(restricao) {
            return restricao.properties.descricao_auto_infracao || '';
        },

        getArea(restricao) {
            return formatters.formatNumber(restricao.properties.areaHa, 2);
        }
    },
    mounted() {
        this.configureLayersMapa();
    }
};
</script>
